<template>
	<TreeListView :items="items" @selected="selectedZone" :selectKeyboardListeners="selectKeyboardListeners" :showIndex="true"></TreeListView>
</template>

<script>
	import { Component, Vue, Prop } from 'vue-property-decorator';
	import { Getter, Action } from 'vuex-class';
	import DefaultLayout from '../../layouts/Default';
	import Dialog from '../../components/Dialog';
	import TreeListView from '../../components/TreeListView';

	@Component({
		components: {
			DefaultLayout,
			Dialog,
			TreeListView
		},
	})
	export default class ViewZones extends Vue {
		@Getter('api/homey/zones/all') zones;
		@Action('api/homey/zones/retrieveAll') getZones;
		@Prop(Array) selectKeyboardListeners;

		async mounted() {
			await this.getZones();
		}

		get items() {
			if (!this.zones) return [];

			// Generate tree with levels and sort hierarchically
			return this.sortZones(this.generateZoneTree(this.zones))
				.map(zone => ({
					title: zone.name,
					level: zone.level,
					id: zone.id,
				}));
		}

		selectedZone(zone) {
			this.$emit('selected', zone);
		}

		sortZones(zones) {
			return [].concat(...zones.map(this.sortZone));
		}

		sortZone(zone) {
			return [zone].concat(...(zone && zone.children ? zone.children.map(this.sortZone) : [[]]));
		}

		generateZoneTree(zones) {
			const rootZones = zones.filter(zone => !zone.parent);
			return rootZones.map(zone => this.getZoneTreeObject(zones, zone, 0));
		}

		getZoneTreeObject(zones, zone, level) {
			const children = zones
				.filter(childZone => childZone.parent && childZone.parent === zone.id)
				.map(childZone => this.getZoneTreeObject(zones, childZone, level + 1))
				.sort((a,b) => a.index-b.index);
			return Object.assign({level}, zone, children.length ? {children} : {});
		}
	}
</script>

<style lang="scss">

</style>